
import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_ALL_WORK_GROUP_BY_MANDATE } from "../Schema/WorkGroup";

export const useGetAllWorkGroupByMandate = () => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const { refetch } = useQuery(GET_ALL_WORK_GROUP_BY_MANDATE, {
    onCompleted: ({ getAllWorkGroupByMandate }) => {
      setTableData(getAllWorkGroupByMandate)
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, []);

  return {
    refetch,
    loading,
    tableData,
    setLoading,
  };
};
